export default "__VITE_ASSET__BzgRCuEN__"